import React, { useEffect, useState } from "react";
import { useCart } from "../context/CartContext";
import toast, { Toaster } from "react-hot-toast";
import { db } from "../firebase"; // make sure firebase is configured
import { doc, setDoc, updateDoc,getDoc } from "firebase/firestore";
import { useAuth } from "../context/AuthContext"; // assuming you use this
import { Link } from "react-router-dom";

const Cart = () => {
  const { cart, removeFromCart, updateQuantity } = useCart();
  const [promoCode, setPromoCode] = useState("");
  const { user } = useAuth(); // from AuthContext
  const { cartItems, setCartItems } = useCart(); // from CartContext

  // Load cart when user logs in
  useEffect(() => {
    const loadCart = async () => {
      if (user) {
        try {
          const cartRef = doc(db, "carts", user.uid);
          const docSnap = await getDoc(cartRef);
          if (docSnap.exists()) {
            setCartItems(docSnap.data().items);
            console.log("Loaded cart from Firestore");
          }
        } catch (err) {
          console.error("Error loading cart:", err);
        }
      }
    };

    loadCart();
  }, [user, setCartItems]);

  // Sync cart to Firestore when cart changes
  useEffect(() => {
    const syncCart = async () => {
      if (user && cartItems.length > 0) {
        try {
          const cartRef = doc(db, "carts", user.uid);
          const simplifiedItems = cartItems.map((item) => ({
            productId: item.product.id,
            quantity: item.quantity,
          }));
          await setDoc(cartRef, { items: simplifiedItems });
          console.log("Synced cart to Firestore");
        } catch (err) {
          console.error("Error syncing cart:", err);
        }
      }
    };

    syncCart();
  }, [cartItems, user]);

   


  const subtotal = cart.reduce((sum, item) => {
    return sum + item.price * item.quantity;
  }, 0);

  const gst = subtotal * 0.18;
  const total = subtotal + gst;

  const saveCartToFirestore = async (userId, cartItems) => {
  try {
    const cartRef = doc(db, "carts", userId);
    await setDoc(cartRef, {
      items: cartItems, // e.g., [ { productId: "abc123", quantity: 2 }, ... ]
    });
    console.log("Cart saved successfully!");
  } catch (error) {
    console.error("Error saving cart:", error);
  }
};
  const updateCartInFirestore = async (userId, newItems) => {
  try {
    const cartRef = doc(db, "carts", userId);
    await updateDoc(cartRef, {
      items: newItems, // partial or complete array
    });
    console.log("Cart updated successfully!");
  } catch (error) {
    console.error("Error updating cart:", error);
  }
};

  const handlePromoCode = () => {
    if (promoCode.trim()) {
      toast.success("Promo code applied (not yet functional)");
    } else {
      toast.error("Please enter a valid promo code");
    }
  };

  return (
    <main className="p-4 sm:p-6 bg-rose-50 min-h-screen">
      <Toaster position="top-right" />

      <h1 className="text-3xl font-bold text-rose-700 mb-6">Your Cart</h1>

      {cart.length === 0 ? (
        <p className="text-gray-600">Your cart is empty.</p>
      ) : (
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Cart Items List - Right Side on Desktop */}
          <div className="lg:w-3/4 space-y-4">
            {cart.map((item) => (
              <div
                key={item.id}
                className="bg-white p-4 rounded-xl shadow flex flex-col sm:flex-row items-center sm:items-start gap-4"
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-24 h-24 object-cover rounded-md"
                />
                <div className="flex-1 w-full">
                  <h2 className="text-xl font-semibold">{item.name}</h2>
                  <p className="text-gray-600">₹{item.price} each</p>
                  <div className="flex items-center mt-2 gap-2">
                    <label htmlFor="quantity" className="text-gray-700">Qty:</label>
                    <input
                      type="number"
                      min="1"
                      value={item.quantity}
                      onChange={(e) =>
                        updateQuantity(item.id, parseInt(e.target.value))
                      }
                      className="w-16 px-2 py-1 border rounded text-center"
                    />
                  </div>
                </div>
                <div className="text-right sm:text-left">
                  <p className="text-lg font-bold">
                    ₹{(item.price * item.quantity).toFixed(2)}
                  </p>
                  <button
                    onClick={() => removeFromCart(item.id)}
                    className="text-sm text-rose-500 hover:underline mt-1"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Summary - Left Side on Desktop */}
          <div className="lg:w-1/4 bg-white p-6 rounded-xl shadow space-y-4">
            <h2 className="text-xl font-semibold text-rose-600">Order Summary</h2>
            <div className="text-gray-700 space-y-1">
              <p>Subtotal: ₹{subtotal.toFixed(2)}</p>
              <p>GST (18%): ₹{gst.toFixed(2)}</p>
            </div>
            <hr />
            <p className="text-xl font-bold text-rose-700">Total: ₹{total.toFixed(2)}</p>

            <input
              type="text"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              placeholder="Promo code"
              className="w-full px-3 py-2 border rounded-md"
            />
            <button
              onClick={handlePromoCode}
              className="bg-rose-600 hover:bg-rose-700 text-white px-4 py-2 rounded w-full"
            >
              Apply Promo Code
            </button>

            <Link to="/checkout" className="block mt-4 bg-green-600 hover:bg-green-700 text-white text-center px-4 py-2 rounded w-full">
                Proceed to Checkout
            </Link> 
          </div>
        </div>
      )}
    </main>
  );
};

export default Cart;
